export enum CALC_TIMEOUT_IN_MINUTES {
    LOCAL = 10,
    DEFAULT = 2
}

export const STORAGE_CALC_PROGRESS_KEY = 'AHUD_LITE_CALC_PROGRESS';
export const STORAGE_CALC_JOB_ID_KEY = 'AHUD_LITE_CALC_JOB_ID';
